import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { User } from '../../../models/user';
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";


@Component({
    selector: 'app-phrases',
    templateUrl: './phrases.component.html',
  providers: [ SharedService,PopupSegmentComponent]

})
export class PhrasesComponent implements OnInit {
errormessage = '';
charFlag :boolean = false;
createFlag : boolean = false;
data = [];
phrase ='';
searchPhraseText ='';
editFlag = [];
editFlagerror = [];
itemsTotalAdv : number =0;
page : number =1;
 user = new User();
id ='';
 objLoaderStatus: boolean = false;
 messageCreate ="";
 showcancel: boolean = false;
 searchmessage = "";
 errormessageChar = "";
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private router: Router,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {
    this.user.objLoaderStatus = false;
  
    }

  

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
        var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
this.localstorage.setStorage("country",'');

  this.shareService.CallDatawithToken("admin/getAllPhrases?currentSize=25", null, token).subscribe((result) => {
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);

    }
         });

    }




deletePhrase(id){
        var token = this.localstorage.getStorage("token");
        //this.id = id;
       this.showConfirmDelete(id);
}

changeFlag(id){
   this.errormessage ="";
    this.errormessageChar ="";
    this.searchmessage = "";
     this.searchPhraseText ="";
  this.id = id;
  console.log(this.data);
  var i=0;
  for(i=0;i<this.data.length;i++){
    this.editFlag[this.data[i].id] = false;
    console.log(this.data[i].id == id);
if(this.data[i].id == id){
this.editFlag[id] = true;
console.log("true"+this.editFlag[id]);
}
// else{
//   this.editFlag[id] = false;
//   console.log("false"+this.editFlag[id]);

// }

  }

}

editPhrase(id,phrase){
    this.errormessage ="";
    this.errormessageChar ="";
    this.searchmessage = "";
     this.searchPhraseText ="";
        var token = this.localstorage.getStorage("token");
        //this.id = id;
                 this.createFlag = false;
                 phrase = encodeURIComponent(phrase);
             if(phrase.trim() !== ''){
                           this.loaderService.displayLoader(true);

this.shareService.callApiWithToken("admin/updatePhrase?id="+id+"&phrase="+phrase,{},token).subscribe((result) => {
    console.log(result.data);
    if(result.data && result.data.status == true){
       this.showUpdate();
       this.editFlag[id] = false;
           this.loaderService.displayLoader(false);

//window.location.reload();    
    }
    else{
          this.loaderService.displayLoader(false);
     this.messageCreate = result.meta.message;
 this.showCreateAlready();   
    }
});
             }
 else{
   this.editFlagerror[id] = true;
              this.errormessage = "Please enter Phrase";
            }
}

createPhrase(phrase){
    this.errormessage ="";
    this.errormessageChar ="";
    this.searchmessage = "";
     this.searchPhraseText ="";
      var token = this.localstorage.getStorage("token");
        //this.id = id;
         this.createFlag = false;
                 phrase = encodeURIComponent(phrase);

            if(phrase.trim() !== ''){
                          this.loaderService.displayLoader(true);

this.shareService.callApiWithToken("admin/createPhrase?phrase="+phrase,{},token).subscribe((result) => {
    console.log(result);
    if(result.data != undefined && result.data.status == true){
      this.messageCreate = "Phrase Created Successfully";
      this.showCreate();   
     }
else{
      this.loaderService.displayLoader(false);
this.messageCreate = result.meta.message;
 this.showCreateAlready();   
    //alert(result.meta.message);
}
    this.loaderService.displayLoader(false);
});
            }
            else{
              console.log("inside else");
              this.createFlag = true;
              this.errormessage = "Please enter Phrase";
            }
}

nextPhrase(event){
this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
    this.errormessage ="";
    this.errormessageChar ="";
    this.searchmessage = "";
    this.searchPhraseText = this.searchPhraseText.trim();
    if(this.searchPhraseText =='' || this.searchPhraseText == undefined){
          this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllPhrases?currentPage="+event+"&currentSize=25", null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
      }
       else{
        this.searchmessage = "No records found";
      }
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
       if(this.searchPhraseText.length<2){
this.errormessageChar = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                   this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("admin/searchPhrase?currentPage="+event+"&currentSize=25&q="+this.searchPhraseText, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
     else{
        this.searchmessage = "No records found";
      }
              this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
        
}

allPhrase(){
        this.itemsTotalAdv = 0;
  this.page = 1;
  this.errormessage ="";
    this.searchmessage = "";
        this.errormessageChar ="";

  this.searchPhraseText = '';
   var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllPhrases?currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);

    }
         });
}

searchPhrase(searchPhraseText){
    this.itemsTotalAdv =0;
      var token = this.localstorage.getStorage("token");
        //this.id = id;
          this.page = 1;

            this.errormessage ="";
            this.searchmessage =  "";
                this.errormessageChar ="";

                this.searchPhraseText = this.searchPhraseText.trim();
if(searchPhraseText.length == 0){
this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllPhrases?currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);

    }
         });
}

        else if(searchPhraseText.length<2 && searchPhraseText.length>0){
this.errormessageChar = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                  this.loaderService.displayLoader(true);

 this.shareService.CallDatawithToken("admin/searchPhrase?currentPage=1&currentSize=25&q="+searchPhraseText, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
    else{
        this.searchmessage = "No records found";
      }
              this.loaderService.displayLoader(false);

    }
         });
       }
}

 

showCreate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Phrase Information', 
                message:this.messageCreate,
              data: [],
            showcancel : this.showcancel})
                .subscribe((isConfirmed)=>{
                  
                   window.location.reload(); 
                });
        }

        showCreateAlready() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Phrase Information', 
                message:this.messageCreate,
              data: [],
            showcancel : this.showcancel})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                 
                });
        }

showDelete() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Phrase Information', 
                message:'Phrase Deleted Successfully',
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                    window.location.reload();
                  }
                });
        }

        showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Phrase Information', 
                message:'Phrase Updated Successfully',
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 
                });
        }

        

        showConfirmDelete(id){
                  var token = this.localstorage.getStorage("token");
this.showcancel = true;
let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Phrase Information', 
                message:'Are you sure you want to delete the Phrase?',
              data: [],
            showcancel : this.showcancel})
                .subscribe((isConfirmed)=>{
 if(isConfirmed){
              this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/deletePhrase?id="+id,{},token).subscribe((result) => {
    console.log(result.data);
    if(result.data.status == true){
      this.showDelete();   
    }

    this.loaderService.displayLoader(false);

});
 }
                });

        }
   
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/phrases/phrases.component.ts